import React, { CSSProperties } from 'react';
import { Grid } from '@material-ui/core';
import { ArtistInfoChipProps } from 'common/components/ArtistInfoChip/ArtistInfoChip';
import { BasicImageTypePropsExtra } from 'common/components/Image/types';
import ArtworkCardComponents from '../common';
import CustomCardComponents from './components';
import { ArtworkInformationProps } from '../common/ArtworkInformation';

export type GenericArtworkCardPreviewProps = {
  artistChipProps?: ArtistInfoChipProps;
  imageProps?: BasicImageTypePropsExtra<{
    aspectRatio?: CSSProperties['aspectRatio'];
    blur?: number;
  }>;
  isSquare?: boolean;
  artworkInfoProps?: ArtworkInformationProps;
  cardCTAPreview?: React.ReactNode;
};

export const GenericArtworkCardPreview: React.FC<GenericArtworkCardPreviewProps> = React.memo(
  ({ isSquare, imageProps, artistChipProps, artworkInfoProps, cardCTAPreview }) => (
    <ArtworkCardComponents.SwipeCardTopBottomLayout>
      <></>
      <ArtworkCardComponents.ImageInfoLayout>
        <ArtworkCardComponents.ArtworkInformation {...(artworkInfoProps ?? {})} />
        {!isSquare ? (
          <ArtworkCardComponents.SoloAspectRatioImage {...(imageProps ?? {})} />
        ) : (
          <ArtworkCardComponents.SoloSquareImage {...(imageProps ?? {})} />
        )}
      </ArtworkCardComponents.ImageInfoLayout>
      <ArtworkCardComponents.FooterLayout>
        <Grid item style={{ minWidth: '40%' }}>
          <CustomCardComponents.ArtistInfoChip {...(artistChipProps ?? {})} />
        </Grid>
        <Grid item style={{ flexShrink: 0 }}>
          {cardCTAPreview}
        </Grid>
      </ArtworkCardComponents.FooterLayout>
    </ArtworkCardComponents.SwipeCardTopBottomLayout>
  )
);
